const TestimonialsJSON = [
    {
        name: "Sushil Ragde",
        org: "Nisarg Fresh",
        content: "Timely completion of projects and follows the commitments"
    },
    {
        name: "Vaishali Taware",
        org: "Director SMART",
        content: "It was good experience working with team of Infinity Tech Resources. The team provided ideas and was quick to action."
    },
    {
        name: "Anil Hajgude",
        org: "Diagnostic Centre, Maharashtra",
        content: "Great Experience working with team of infinity Tech Resources, provide immovative solutions."
    }

]

export default TestimonialsJSON